import React, { useEffect, useState } from "react";
import SideBar from "./components/SideBar";
import logo from "../assets/01pos.webp";
import { Outlet } from "react-router";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router";
import Notification from "./components/Notification";
import Chat from "./components/Chat";
import NotificationPopup from "./components/NotificationPopup";

function AdminDashboard() {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [openMessage, setOpenMessage] = useState(false);

  const toggleNotification = () => {
    setIsNotificationOpen((prev) => !prev);
    setOpenMessage(false);
  };
  return (
    <div className="h-screen lg:overflow-y-hidden ">
      {/* Header */}
      <div className="h-16 bg-white flex justify-between lg:justify-normal lg:gap-24 items-center px-8">
        <img src={logo} alt="logo" className="w-24" />
        <div className="flex lg:flex-grow flex-shrink justify-between">
          <div className="flex-col hidden lg:block lg:px-4">
            <h2 className="text-2xl font-medium">Welcome back</h2>
            <p>Admin</p>
          </div>
          <div className="flex text-gray-600 gap-4 items-center">
            <Chat
              setOpenMessage={setOpenMessage}
              openMessage={openMessage}
              setIsNotificationOpen={setIsNotificationOpen}
            />
            <Notification
              toggleNotification={toggleNotification}
              setNotifications={setNotifications}
            />

            <Link to="profile">
              <AccountCircleIcon className="text" sx={{ fontSize: 40 }} />
            </Link>
          </div>
        </div>
      </div>

      {isNotificationOpen && (
        <NotificationPopup
          toggleNotification={toggleNotification}
          notifications={notifications}
        />
      )}

      <div className="flex  h-screen flex-row ">
        <SideBar />
        {/* right bar */}
        <div className="lg:w-10/12 w-full bg-gray-100 h-full p-5 pb-24 overflow-x-auto overflow-y-visible lg:overflow-y-scroll">
          {/* COmpany total information */}
          <Outlet />
          {/* Other data */}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
